<div class="inner">
    <h1 class="title">{{ title }}</h1>
</div>
